import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import Link from '../../../components/Link';

import s from './Revvy.scss';

class Revvy extends React.Component {
  render() {
    return (
      <>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/"
                >
                  <span itemProp="name">Home</span>
                </Link>
                <meta content="0" itemProp="position" />
              </li>
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/portfolio"
                >
                  <span itemProp="name">Portfolio</span>
                  <meta content="1" itemProp="position" />
                </Link>
              </li>
              <li>Revvy</li>
            </ul>
          }
          header="Revvy"
          link="https://gorevvy.com"
          subHeader="Revvy is a product review startup designed to be the go to place to make a well informed purchasing decision."
        />
        <section className={s.shadower}>
          <div className={s.about}>
            <div className={s.content}>
              <h3>About Revvy</h3>
              <p>
                The initial concept of Revvy came from Yelp. We wanted there to
                be a single source of information for all product reviews.
              </p>
              <p>
                Revvy allows users to quickly gain insight into how people
                really feel about the products they use day to day.
              </p>
              <p>
                On Revvy, users can create their own content share with their
                friends and leave feedback on other people's reviews.
              </p>
            </div>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/revvy-home.png"
              />
            </div>
          </div>

          <div className={s.challenge}>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/revvy-follow.png"
              />
            </div>
            <div className={s.content}>
              <h3>Challenge</h3>
              <p>
                The challenge was originally to create something that could be
                the single source of product reviews. Over time that evolved as
                we recognized business challenges that needed to be overcome.
              </p>
            </div>
          </div>

          <div className={s.about}>
            <div className={s.content}>
              <h3>Solution</h3>
              <p>
                We created a social product review platform where users can
                create and share product review content in an easy engaging way.
              </p>
            </div>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/revvy-profile.png"
              />
            </div>
          </div>

          <Grid>
            <Row>
              {/* <Col md={12}>
                <div className={s.laptopPreview}>
                  <img
                    alt="Concept Drawn"
                    src="/images/uncompressed/shadower-mockup-macbook1.png"
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className={s.mobilePreview}>
                  <img
                    alt="Concept Drawn"
                    src="/images/uncompressed/shadower-mockup-iphone1.png"
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className={s.mobilePreview}>
                  <img
                    alt="Concept Drawn"
                    src="/images/uncompressed/shadower-mockup-iphone5.png"
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className={s.linkToWebsiteContainer}>
                  <a href="https://gorevvy.com">Visit Website</a>
                </div>
              </Col> */}
              <Col md={12}>
                <div className={s.review}>
                  <img
                    alt="Jason Pacini"
                    src="/images/uncompressed/jason-poster.jpg"
                  />
                  <blockquote>
                    I have been working with Flux Teck for a couple months now
                    to build a web-based application and it has been a very
                    smooth experience. Jonathan and Dan are very knowledgeable
                    and professional.
                    <br />
                    <br />
                    <span>- Jason Pacini | Founder, Revvy</span>
                  </blockquote>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
      </>
    );
  }
}

export default withStyles(s)(Revvy);
